<template>
	<div class="calendar-container" :style="style()">
		<div class="calendar ms-dropdown">
			<div :class="['calendar-header', 'flex', 'items-center']">
				<div class="pre-month" @click="previousMonth">
					<div class="mi mi-24 mi-icon-pre-page"></div>
				</div>
				<div class="calender-current-date flex-1" @click="setSelecting('year')">
					<span>{{
						`${selecting === 'date' ? currentMonthText : ''}${selectedYear}`
					}}</span>
				</div>
				<div class="next-month" @click="nextMonth">
					<div class="mi mi-24 mi-icon-next-page"></div>
				</div>
			</div>
			<!-- <div class="separate-line-header"></div> -->
			<div class="calendar-body">
				<table class="calendar-table">
					<thead>
						<tr>
							<th v-for="(value, key) in dayMap" :key="key">{{ value }}</th>
						</tr>
					</thead>
					<tbody class="date-in-month">
						<tr>
							<td colspan="7" class="space-calendar-body"></td>
						</tr>
						<tr v-for="(days, index) in calendar" :key="index">
							<td
								:class="[
									day.day !== '' ? 'date-in-table' : '',
									'ms-date',
									{
										'ms-date-day-seleted': day.selected && day.day,
										'ms-date-current': day.currentDay,
									},
									{ disabled: checkMinDate(day) },
									{ disabled: checkMaxDate(day) },
								]"
								v-for="(day, index) in days"
								:key="index"
								@keydown.esc="onClose"
								@click.exact="setByDay(day), setSelecting('date')"
							>
								{{ day.day }}
							</td>
						</tr>
					</tbody>
				</table>
				<!-- <h2>{{selectedDay}} {{selectedMonthWord}} {{selectedYear}}</h2> -->
				<div class="separate-line"></div>
			</div>
			<div class="calendar-year-select" v-show="selecting === 'year'">
				<!-- <div class="arrow-down"></div> -->
				<div class="separate-line"></div>
				<table>
					<transition-group name="slide-fade" tag="tbody">
						<tr v-for="(yearList, index) in years" :key="index + 0">
							<td
								class="year"
								:class="{ selected: year.selected }"
								:id="`${year.year}-calendar-year`"
								v-for="(year, index) in yearList"
								:key="index"
								@click="setByYear(year.year)"
							>
								<div
									:class="[
										'ms-datepicker-year',
										{ 'ms-datepicker-year-selected': year.selected },
									]"
								>
									{{ year.year }}
								</div>
							</td>
						</tr>
					</transition-group>
				</table>
				<div class="separate-line"></div>
				<button class="cancel-button" @click="setSelecting('date')">
					{{ $t('i18nCommon.ClosePop') }}
				</button>
			</div>
			<!-- <div class="calendar-month-select" v-if="selecting === 'month'">
                <table>
                    <tbody>
                        <tr v-for="(month, index) in monthMap" :key="index"></tr>
                    </tbody>
                </table>
			</div>-->
			<div class="time" v-if="hasTime">
				<ms-label bold class="mr-12-px">{{ $t('i18nCommon.Times') }}:</ms-label>
				<div class="change-hour">
					<!-- <div class="button-change">
             <ms-icon icon='icon-arrow-up' iconPack='feather'></ms-icon>
            <ms-icon icon='icon-arrow-down' iconPack='feather'></ms-icon>
					</div>-->
					<ms-number
						@keydown.enter="updateHour"
						@input="onInputHour"
						v-model="hour"
						max="23"
						min="0"
						isTime
						leadingZero="keep"
						class="input-time"
					/>
				</div>
				<ms-label class="mr-6-px ml-6-px">:</ms-label>
				<div class="change-minute">
					<ms-number
						ref="min"
						@keydown.enter="updateMin"
						@input="onInputMin"
						v-model="min"
						max="60"
						min="0"
						isTime
						leadingZero="keep"
						class="input-time"
					/>
					<!-- <div class="button-change">
            <ms-icon icon='icon-arrow-up' iconPack='feather'></ms-icon>
            <ms-icon icon='icon-arrow-down' iconPack='feather'></ms-icon>

					</div>-->
				</div>
				<ms-label class="mr-6-px ml-6-px">:</ms-label>
				<div class="change-second">
					<ms-number
						ref="second"
						@keydown.enter="updateSecond"
						@input="onInputSecond"
						v-model="second"
						max="60"
						min="0"
						isTime
						leadingZero="keep"
						class="input-time"
					/>
					<!-- <div class="button-change">
            <ms-icon icon='icon-arrow-up' iconPack='feather'></ms-icon>
            <ms-icon icon='icon-arrow-down' iconPack='feather'></ms-icon>
					</div>-->
				</div>
			</div>
			<div class="calendar-footer">
				<button class="pick-today-button" @click.stop.prevent="onNow">
					{{ $t('i18nCommon.ToDay') }}
				</button>
			</div>
			<!-- <h2>{{ selectedDay }} {{ selectedMonthWord }} {{selectedYear}}</h2> -->
		</div>
	</div>
</template>

<script>
/* --------------------------------
 * Hàm tách mảng
 */
const slice = (array, start, end) => {
	let length = array == null ? 0 : array.length;

	if (!length) {
		return [];
	}

	start = start == null ? 0 : start;

	end = end === undefined ? length : end;

	if (start < 0) {
		start = -start > length ? 0 : length + start;
	}

	end = end > length ? length : end;

	if (end < 0) {
		end += length;
	}

	length = start > end ? 0 : (end - start) >>> 0;
	start >>>= 0;

	let index = -1;

	const result = new Array(length);

	while (++index < length) {
		result[index] = array[index + start];
	}

	return result;
};
/** -----------------------------
 * Hàm tách mảng thành nhiều mảng nhỏ có độ dài cho trước
 * @param {arrays, size}
 * -------------------------------
 */
const chunk = (array, size) => {
	size = Math.max(size, 0);

	const length = array == null ? 0 : array.length;

	if (!length || size < 1) {
		return [];
	}

	let index = 0;

	let resIndex = 0;

	const result = new Array(Math.ceil(length / size));

	while (index < length) {
		result[resIndex++] = slice(array, index, (index += size));
	}

	return result;
};

//Hiện tại chưa thấy sử dụng dữ liệu này
const monthMap = {
	0: 'Tháng 1',
	1: 'Tháng 2',
	2: 'Tháng 3',
	3: 'Tháng 4',
	4: 'Tháng 5',
	5: 'Tháng 6',
	6: 'Tháng 7',
	7: 'Tháng 8',
	8: 'Tháng 9',
	9: 'Tháng 10',
	10: 'Tháng 11',
	11: 'Tháng 12',
};
// @ is an alias to /src
import msBaseComponentDefaultVue from '@/components/msbase/msBaseComponentDefault.vue';
export default {
	name: 'datepicker',
	extends: msBaseComponentDefaultVue,
	data() {
		let dteNow = new Date();

		return {
			// hour: `${this.getTime() ? this.getTime()[0] : '00'}`,
			// min: `${this.getTime() ? this.getTime()[1] : '00'}`,
			// second: `${this.getTime() ? this.getTime()[2] : '00'}`,
			hour: 0,
			min: 0,
			second: 0,
			dayMap: {
				0: 'T2',
				1: 'T3',
				2: 'T4',
				3: 'T5',
				4: 'T6',
				5: 'T7',
				6: 'CN',
			},
			currentMonth: `${dteNow.getMonth()}`, // tháng 6
			currentYear: `${dteNow.getFullYear()}`,
			selecting: 'date',
			selectedDayRange: [],
			selectedDayOfWeek: '',
			selectedDay: dteNow.getDate(),
			selectedMonth: `${dteNow.getMonth()}`,
			selectedYear: `${dteNow.getFullYear()}`,
			rangeDayMode: false, // chế độ khoảng thời gian, mặc định là không bật
			height: '',
			width: '',
		};
	},
	watch: {
		// time(value) {
		// 	this.hour = `${this.getTime() ? this.getTime()[0] : '00'}`;
		// 	this.min = `${this.getTime() ? this.getTime()[1] : '00'}`;
		// 	this.second = `${this.getTime() ? this.getTime()[2] : '00'}`;
		// },
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				if (newVal && newVal instanceof Date) {
					me.hour = newVal.getHours();
					me.min = newVal.getMinutes();
					me.second = newVal.getSeconds();
				}
			},
		},
	},
	props: {
		hasTime: {
			type: Boolean,
			default: false,
		},
		// time: {
		// 	type: String,
		// 	default: new Date().getHours() + ':' + new Date().getMinutes()
		// },
		colorSelected: {
			type: String,
			required: false,
			default: '#08BF1E',
		},
		backgroundSelected: {
			type: String,
			required: false,
			default: 'rgba(44, 160, 28, 0.2)',
		},
		yearSelected: {
			type: String,
			required: false,
			default: '#fff',
		},
		value: {},

		screenX: {
			type: Number,
			required: true,
		},
		screenY: {
			type: Number,
			required: true,
		},
		minDate: {},
		maxDate: {},
	},
	methods: {
		initDataStatic() {
			const me = this,
				weekDays = [
					`${me.$t('i18nCommon.WeekDays.Sunday')}`,
					`${me.$t('i18nCommon.WeekDays.Monday')}`,
					`${me.$t('i18nCommon.WeekDays.Tuesday')}`,
					`${me.$t('i18nCommon.WeekDays.Wednesday')}`,
					`${me.$t('i18nCommon.WeekDays.Thursday')}`,
					`${me.$t('i18nCommon.WeekDays.Friday')}`,
					`${me.$t('i18nCommon.WeekDays.Saturday')}`,
				];
			let autoGenIndex = 1;
			if (me.$i18n.isEnglish) {
				autoGenIndex = 0;
			}
			me.dayMap = {
				0: weekDays[autoGenIndex],
				1: weekDays[autoGenIndex + 1],
				2: weekDays[autoGenIndex + 2],
				3: weekDays[autoGenIndex + 3],
				4: weekDays[autoGenIndex + 4],
				5: weekDays[autoGenIndex + 5],
				6: weekDays[(autoGenIndex + 6) % 7],
			};
		},
		checkMinDate(day) {
			if (this.minDate) {
				if (this.selectedYear < this.minDate.getFullYear()) {
					return true;
				}
				if (this.selectedYear > this.minDate.getFullYear()) {
					return false;
				}
				if (this.currentMonth < this.minDate.getMonth()) {
					return true;
				}
				if (
					this.currentYear == this.minDate.getFullYear() &&
					this.currentMonth == this.minDate.getMonth() &&
					day.day < this.minDate.getDate()
				) {
					return true;
				}
			}
			return false;
		},
		checkMaxDate(day) {
			if (this.maxDate) {
				if (this.selectedYear > this.maxDate.getFullYear()) {
					return true;
				}
				if (this.currentMonth > this.maxDate.getMonth()) {
					return true;
				}
				if (
					this.currentYear == this.maxDate.getFullYear() &&
					this.currentMonth == this.maxDate.getMonth() &&
					day.day > this.maxDate.getDate()
				) {
					return true;
				}
			}
			return false;
		},
		onInputHour() {
			// hàm này kiểm tra focus sang input min
			const me = this,
				hour = me.hour;
			if (
				(hour.toString().length === 1 && hour >= 3) ||
				hour.toString().length === 2
			) {
				me.updateTime(hour, null, null);
			}
		},

		onInputMin() {
			const me = this,
				min = me.min;
			if (
				(min.toString().length === 1 && min >= 6) ||
				min.toString().length === 2
			) {
				me.updateTime(null, min, null);
			}
		},

		onInputSecond() {
			const me = this,
				second = me.second;

			if (
				(second.toString().length === 1 && second >= 6) ||
				second.toString().length === 2
			) {
				//update ra ngoai
				me.updateTime(null, null, second);
			}
		},

		updateHour() {
			this.updateTime(this.hour, null, null);
		},

		updateMin() {
			this.updateTime(null, this.min, null);
		},

		updateSecond() {
			this.updateTime(null, null, this.second);
		},

		/**
		 * Thực hiện cập nhật Giờ/Phút/Giây
		 */
		updateTime(hour, min, second) {
			const me = this;

			let valueDateTime = me.value;
			if (valueDateTime && valueDateTime instanceof Date) {
				if (hour) {
					valueDateTime.setHours(hour);
				}
				if (min) {
					valueDateTime.setMinutes(min);
				}
				if (second) {
					valueDateTime.setSeconds(second);
				}

				this.$emit('input', valueDateTime);
			}
		},

		style() {
			//Chieu cao cua cua so
			let height =
				window.innerHeight ||
				document.documentElement.clientHeight ||
				document.body.clientHeight;
			let width =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			let top = 36 + 'px';

			//this.screenY laf vi tri cua
			if (this.screenY + this.height + 100 > height) {
				top = -this.height - 36 + 'px';
			}
			if (this.screenX - this.width < 200) {
				return {
					left: 0 + 'px',
					top: top,
				};
			} else
				return {
					right: 0 + 'px',
					top: top,
				};
		},

		/**
		 * Changes the display to the calendar or years depending on the value.
		 */
		/*---------------------------------
		 * Hàm trả về tháng tiếp theo (hoặc 12 năm tiếp theo) khi bấm mũi tên sang phải (hoặc lên trên)
		 * Created by: nvlam (22/06/2019)
		 */
		nextMonth() {
			if (this.selecting === 'date') {
				if (this.currentMonth < 11) this.currentMonth = +this.currentMonth + 1;
				else {
					this.currentMonth = 0;
					this.selectedYear = +this.selectedYear + 1;
				}
				return this.currentMonth;
			} else if (this.selecting === 'year') {
				this.currentYear = +this.currentYear + 12;
			}
		},

		/*---------------------------------
		 * Hàm trả về tháng trước (hoặc 12 năm về trước) khi bấm mũi tên sang phải (hoặc xuống dưới)
		 * Created by: nvlam (22/06/2019)
		 */
		previousMonth() {
			if (this.selecting === 'date') {
				if (this.currentMonth > 0) this.currentMonth = this.currentMonth - 1;
				else {
					this.currentMonth = 11;
					this.selectedYear = this.selectedYear - 1;
				}
				return this.currentMonth;
			} else if (this.selecting === 'year') {
				this.currentYear -= 12;
			}
		},

		/*---------------------------------
		 * Đóng lịch khi các nút Esc hay Tab được nhấn
		 * Created by: nvlam (22/06/2019)
		 */
		setEscapeEvent() {
			const me = this;
			document.addEventListener('keydown', me.eventEscape);
		},

		eventEscape(event) {
			const me = this;
			if (event.keyCode == 27 || event.key == 'Escape' || event.key == 'Tab') {
				event.cancel = true;
				me.onClose(event);
			}
		},

		setByYear(year) {
			this.selectedDay = '';
			this.selectedYear = year;
			this.currentYear = year;
			this.selecting = 'date';
		},

		onBlur(e) {
			this.onClose(e);
		},

		/*---------------------------------
		 * Chọn ngày hiện tại khi bấm vào nút Hôm nay
		 * Created by: nvlam (24/06/2019)
		 */
		onNow() {
			const me = this,
				date = new Date();

			me.selectedDay = date.getDate();
			me.selectedMonth = date.getMonth();
			me.currentMonth = date.getMonth();
			me.currentYear = date.getFullYear();
			me.selectedYear = date.getFullYear();
			me.selectedDayOfWeek = date.getDay();
			me.setByDay({
				currentDay: true,
				day: me.selectedDay,
				selected: true,
			});

			if (me.hasTime) {
				me.min = date.getMinutes();
				me.hour = date.getHours();
				me.second = date.getSeconds();
				me.updateTime(me.hour, me.min, me.second);
			}
			// me.$emit('input', new Date(date).getDateOnly());
			me.onClose(event);
		},

		/**
		 * Emit a close event so the developer can close the date picker as they
		 * see fit.
		 */
		onClose(e) {
			// this.hideBodyOverflow(false);

			this.$emit('close', e);
		},

		/**
		 * Set the date by the given day.
		 *
		 * @param {Object}
		 */
		setByDay(day) {
			const me = this;
			if (!day.day) return;
			// if (day.disabled) return;
			if (me.rangeDayMode == false) {
				me.currentYear = me.selectedYear;
				me.selectedDay = day.day;
				me.selectedMonth = me.currentMonth;
				me.selectedDayOfWeek = new Date(
					me.currentYear,
					me.selectedMonth,
					day.day
				).getDay();
			}

			let valueDateTime = me.value;
			if (valueDateTime && valueDateTime instanceof Date) {
				valueDateTime.setYear(me.selectedYear);
				valueDateTime.setMonth(me.selectedMonth, day.day);
			}

			me.$emit('selected', new Date(valueDateTime));

			me.onClose(event);
			// this.onInput();
		},
		closeOut(e) {
			const me = this;
			if (
				!e.target.closest('.calendar') &&
				(!e.target.closest('.ms-datepicker') ||
					e.target.closest('.ms-datepicker') != me.$parent.$el)
			) {
				me.onClose(e);
			}
		},
		/*--------------------------------
		 * Bật chế độ chọn khoảng ngày
		 * Created by: nvlam(26/06/2019)
		 */
		onRangeDayMode() {
			this.rangeDayMode = true;
			return this.rangeDayMode;
		},

		/*--------------------------------
		 * Tắt chế độ chọn khoảng ngày
		 * Created by: nvlam(26/06/2019)
		 */
		offRangeDayMode() {
			this.rangeDayMode = false;
			return this.rangeDayMode;
		},

		/*---------------------------------
		 * Hàm thay đổi chế độ chọn năm hoặc chọn ngày
		 * Created by: nvlam(24/06/2019)
		 */
		setSelecting(value) {
			this.selecting = value;
			this.currentYear = this.selectedYear;
		},

		/**
		 * Lấy ngày cho datepicker khi nhập từ ô input.
		 */
		setDate() {
			// Nếu ngày được truyền tới component datepicker, nó sẽ được dùng
			// thay cho ngày hiện tại.
			let date;

			if (this.min && this.min && !this.value) {
				date = new Date();
			} else if (this.value && this.value) {
				date = new Date(this.value);
			} else {
				date = new Date();
			}
			// if (this.initialDate) {
			//     this.selectedDay = date.getDate();
			// } else {
			//     this.selectedDay = date.getDate();
			// }
			this.selectedDay = date.getDate();
			this.selectedDayOfWeek = date.getDay();
			this.selectedMonth = date.getMonth();
			this.currentMonth = date.getMonth();
			this.selectedYear = date.getFullYear();
			this.currentYear = date.getFullYear();
		},
		getMonthKey(currentMonth) {
			switch (currentMonth) {
				case 0:
					return 'January';
				case 1:
					return 'February';
				case 2:
					return 'March';
				case 3:
					return 'April';
				case 4:
					return 'May';
				case 5:
					return 'June';
				case 6:
					return 'July';
				case 7:
					return 'August';
				case 8:
					return 'September';
				case 9:
					return 'October';
				case 10:
					return 'November';
				case 11:
					return 'December';
			}
		},
	},
	computed: {
		/* --------------------------------
		 * Hàm trả về một mảng gồm ngày của tuần đầu tiên trong tháng của năm
		 * VD: Nếu ngày 1 trong tháng bắt đầu từ thứ 6
		 * thì mảng sẽ là ['', '', '', '', '', '1', '2']
		 * Created by: nvlam (22/06/2019)
		 */
		calendar() {
			const days = [];
			//Lấy ra thứ của ngày đầu tiên trong tháng
			const startDayOfMonth = new Date(
				this.selectedYear,
				this.currentMonth,
				1
			).getDay();
			let startDay = startDayOfMonth;
			if (startDayOfMonth != 0) {
				for (let i = 0; i < startDay - 1; i++) {
					days.push('');
				}
			} else {
				for (let i = 0; i < 6; i++) {
					days.push('');
				}
			}
			//Tạo mảng gồm các ngày còn lại trong tháng
			const daysInMonth =
				32 - new Date(this.selectedYear, this.currentMonth, 32).getDate();
			for (let i = 0; i < daysInMonth; i++) {
				days.push(i + 1);
			}

			// Map the days from numbers to objects that have current day,
			// selected, and disabled properties for the view.
			const today = new Date();

			const dayObjects = days.map((day) => {
				const currentDay =
					day === today.getDate() &&
					this.currentMonth == today.getMonth() &&
					this.selectedYear == today.getFullYear();
				const selected =
					this.selectedDay === day && this.currentMonth === this.selectedMonth;

				// const disabled = this.dayDisabled(day);

				// return { day, currentDay, selected, disabled };
				return { day, currentDay, selected };
			});

			// Chunk all of the days into an array of arrays, by seven.
			return chunk(dayObjects, 7);
		},
		years() {
			//Đặt năm đầu tiên của dãy
			let lastYear;
			if (this.selectedYear === '') {
				lastYear = new Date().getFullYear();
			} else lastYear = this.currentYear;
			let through = 12; // số năm hiển thị trên 1 trang
			let years = []; // mảng chứa các năm
			for (let i = lastYear; i > lastYear - through; i--) {
				years.push(i);
			}
			const today = new Date();
			const yearObjects = years.map((year) => {
				const currentYear = this.selectedYear === today.getFullYear();
				const selected =
					this.selectedYear === year &&
					this.currentMonth === this.selectedMonth;
				// const disabled = this.dayDisabled(day);

				// return { day, currentDay, selected, disabled };
				return { year, currentYear, selected };
			});

			// Chunk all of the days into an array of arrays, by seven.
			return chunk(yearObjects, 4);
		},
		/**
		 * Trả về tháng được chọn thành một từ.
		 * VD: 6 -> Tháng 6
		 *
		 * @return {String}
		 */
		selectedMonthWord() {
			return monthMap[this.selectedMonth];
		},
		selectedDateRange() {
			let beginDay = this.selectedDay;
			return beginDay;
		},
		currentMonthText() {
			let currentMonth = this.currentMonth;
			if (this.$i18n.isVietnamese) return `Tháng ` + (currentMonth + 1) + '/';
			else if (this.$i18n.isEnglish)
				return (
					this.$t(`i18nCommon.MonthInfo.${this.getMonthKey(currentMonth)}`) +
					' '
				);
		},
	},
	getValueFromInput() {
		return (this.currentMonth = this.specifiedDate.getMonth());
	},
	created() {
		this.setEscapeEvent();
		this.setDate();
		document.addEventListener('mousedown', this.closeOut);
		this.initDataStatic();
	},
	destroyed() {
		const me = this;
		document.removeEventListener('mousedown', me.closeOut);
		document.removeEventListener('keydown', me.eventEscape);
	},
	mounted() {
		this.height = this.$el.offsetHeight;
		this.width = this.$el.offsetWidth;
	},
};
</script>
<style>
@import '../../assets/css/iconfont.css';
</style>

<style lang="scss" scoped>
@import '@/assets/scss/components/msDatePickerPopup.scss';
.disabled {
	opacity: 0.7;
	pointer-events: none;
}
</style>



